import { render, staticRenderFns } from "./ThreeArticlesSection.vue?vue&type=template&id=515d0511&scoped=true&"
import script from "./ThreeArticlesSection.vue?vue&type=script&lang=js&"
export * from "./ThreeArticlesSection.vue?vue&type=script&lang=js&"
import style0 from "./ThreeArticlesSection.vue?vue&type=style&index=0&id=515d0511&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d0511",
  null
  
)

export default component.exports